// src/components/MenuBook.js

import React, { useState, useEffect, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebase";
import "./MenuBook.css";

const MenuBook = () => {
  const [pages, setPages] = useState([]);
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  // 1) Create a ref to the flipbook instance
  const bookRef = useRef(null);

  // 2) Fetch menu page data from Firestore + Storage
  useEffect(() => {
    const fetchPages = async () => {
      try {
        const pagesRef = collection(db, "menuPages");
        const q = query(pagesRef, orderBy("pageNumber", "asc"));
        const snapshot = await getDocs(q);

        const fetched = await Promise.all(
          snapshot.docs.map(async (docSnap) => {
            const data = docSnap.data();
            const storageReference = storageRef(storage, data.imagePath);
            const url = await getDownloadURL(storageReference);
            return {
              pageNumber: data.pageNumber,
              url,
            };
          })
        );

        setPages(fetched);
      } catch (err) {
        console.error("Error fetching menu pages:", err);
      }
    };

    fetchPages();
  }, []);

  // 3) Update dimensions on window resize (fullscreen)
  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (pages.length === 0) {
    return <div className="menu-loading">Loading menu…</div>;
  }

  // 4) Arrow handlers must invoke the internal `pageFlip()` methods
  const goPrev = () => {
    if (bookRef.current) {
      // Instead of bookRef.current.flipPrev(), use:
      bookRef.current.pageFlip().flipPrev();
    }
  };
  const goNext = () => {
    if (bookRef.current) {
      // Instead of bookRef.current.flipNext(), use:
      bookRef.current.pageFlip().flipNext();
    }
  };

  return (
    <div className="menu-book-wrapper">
      {/* Left Arrow */}
      <button className="arrow left" onClick={goPrev} aria-label="Previous Page">
        ‹
      </button>

      <HTMLFlipBook
        ref={bookRef}
        width={dimensions.width}
        height={dimensions.height}
        minWidth={dimensions.width}
        maxWidth={dimensions.width}
        minHeight={dimensions.height}
        maxHeight={dimensions.height}
        drawShadow={true}
        mobileScrollSupport={false}
      >
        {pages.map((page) => (
          <div key={page.pageNumber} className="menu-page">
            <img
              src={page.url}
              alt={`Menu Page ${page.pageNumber}`}
              className="menu-page-image"
            />
          </div>
        ))}
      </HTMLFlipBook>

      {/* Right Arrow */}
      <button className="arrow right" onClick={goNext} aria-label="Next Page">
        ›
      </button>
    </div>
  );
};

export default MenuBook;
